import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import ManageLoanSearchLayer from "../../../components/Admin/ManageLoanSearchLayer";

const ManageLoanSearch = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title='Add Category' />

        {/* BlankPageLayer */}
        <ManageLoanSearchLayer />
      </MasterLayout>
    </>
  );
};

export default ManageLoanSearch;
